import {EmployeeLeaveList} from "./EmployeeLeaveList";
import {EmployeeLeaveEdit} from "./EmployeeLeaveEdit";
import {EmployeeLeaveCreate} from "./EmployeeLeaveCreate";

export default {
    list: EmployeeLeaveList,
    create: EmployeeLeaveCreate,
    edit: EmployeeLeaveEdit
};
